import _ from 'underscore';

export const getPlacementCardStyles = ({ styleOverrides }) => () => {
  const overrides = _.pick(styleOverrides, [
    'adsLabel',
    'gradient',
    'imageContainer',
    'imageGradient',
    'previewContent',
    'previewTypeString',
    'textContainer',
    'preHeadlineDivider',
    'postHeadlineDivider',
    'additionalDisclaimer',
  ]);

  return {
    gradient: _.extend({
    }, overrides.gradient),
    imageContainer: _.extend({}, overrides.imageContainer),
    imageGradient: _.extend({
    }, overrides.imageGradient),
    previewContent: _.extend({
      display: 'block',
      position: 'relative',
      boxSizing: 'content-box',
      overflow: 'hidden',
      boxShadow: '0px 0.511px 1.533px rgb(0 0 0 / 10%), 0px 2.72533px 6.132px rgb(0 0 0 / 13%)',
      borderRadius: 5.11,
      background: '#fff',
      margin: 'auto',
      top: 0,
    }, overrides.previewContent),
    previewTypeString: _.extend({
      left: 0,
      width: '100%',
      position: 'absolute',
      textAlign: 'center',
      paddingTop: 12,
      fontSize: '14px',
      bottom: 40,
      lineHeight: '20px',
    }, overrides.previewTypeString),
    textContainer: _.extend({
      fontSize: '10px',
      lineHeight: '16px',
    }, overrides.textContainer),
    preHeadlineDivider: _.extend({}, overrides.preHeadlineDivider),
    postHeadlineDivider: _.extend({}, overrides.postHeadlineDivider),
    additionalDisclaimer: _.extend({
      fontSize: 12,
      lineHeight: '20px',
      textAlign: 'left',
      bottom: 0,
      padding: '0 24px',
      position: 'absolute',
      width: '100%',
      left: 0,
    }, overrides.additionalDisclaimer),
  };
};
